import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        {/* Header */}
        <Banner
          config={{
            applyFormRef,
            title: "UI/UX Designer",
          }}
        />

        {/* Content */}
        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            {/* LEFT SIDE: JOB DESCRIPTION */}

            <div className="lg:col-span-2 space-y-12">
              {/* Job Summary Section */}
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We seek a passionate and creative UI/UX Intern to join our
                  team. This internship is an excellent opportunity for students
                  or recent graduates to gain hands-on experience, work on real
                  projects, and build a professional portfolio in a
                  collaborative and creative environment.
                </p>
              </div>

              {/* Key Responsibilities */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Assist in designing graphics for social media posts,
                    banners, brochures, and marketing materials.
                  </li>
                  <li>
                    Support senior designers in day-to-day creative tasks.
                  </li>
                  <li>
                    Work on branding elements like logos, business cards, and
                    digital assets.
                  </li>
                  <li>
                    Take part in brainstorming sessions and contribute creative
                    ideas.
                  </li>
                  <li>
                    Ensure design consistency and alignment with brand
                    guidelines.
                  </li>
                  <li>
                    Collaborate with content writers, marketers, and developers
                    to execute creative projects.
                  </li>
                  <li>Adapt and revise existing designs as per feedback.</li>
                </ul>
              </div>

              {/* Required Skills */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Required Skills
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Proficiency in Adobe Creative Suite (Photoshop, Illustrator,
                    Premiere Pro, After Effects); knowledge of Figma is a plus.
                  </li>
                  <li>
                    Basic understanding of design principles: layout, color,
                    typography, and visual hierarchy.
                  </li>
                  <li>Creative mindset with attention to detail.</li>
                  <li>Good communication skills and willingness to learn.</li>
                  <li>
                    Ability to work under deadlines and take constructive
                    feedback positively.
                  </li>
                  <li>
                    Portfolio (academic, freelance, or personal projects)
                    showcasing design skills.
                  </li>
                </ul>
              </div>
            </div>

            {/* RIGHT SIDE: JOB INFORMATION */}
            <JobInformation />
          </div>
        </div>

        {/* Apply Form */}
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
